<template>
  <div>
    <ExpandableSection
      class="grade-group"
      v-for="group in schedule"
      :key="keyPrefix + group.grade"
      :title="getGradeName(group.grade)"
    >
      <div class="item" v-for="(record, index) in group.records" :key="index">
        <CourseScheduleRow class="info" :record="record" />
      </div>
    </ExpandableSection>
  </div>
</template>

<script>
import ExpandableSection from "@/components/ExpandableSection.vue";
import CourseScheduleRow from "@/components/CourseScheduleRow.vue";
import { getGradeName } from "@/utils/grades.js";
import _ from "lodash";

export default {
  components: {
    ExpandableSection,
    CourseScheduleRow
  },
  props: {
    schedules: {
      default: []
    },
    keyPrefix: {
      default: ""
    }
  },
  data() {
    return {
      schedule: []
    };
  },
  mounted() {
    this.groupCourseSchedule();
  },
  watch: {
    $props: {
      handler() {
        this.groupCourseSchedule();
      },
      deep: true
    }
  },
  methods: {
    groupCourseSchedule() {
      this.schedule = Object.values(
        this.schedules.reduce((acc, it) => {
          acc[it.grade] = acc[it.grade] || [];
          acc[it.grade].push(it);
          return acc;
        }, {})
      )
        .map(it => {
          window.console.log("it", it);
          const group = _.groupBy(it, "subjects");
          const recordArray = _.flatMap(group);
          recordArray.sort((a, b) =>
            a.subjects.length < b.subjects.length ? 1 : -1
          );
          return {
            grade: it[0].grade,
            records: recordArray
          };
        })
        .sort((a, b) => (a.grade > b.grade ? 1 : -1));
    },
    getGradeName: getGradeName
  }
};
</script>

<style lang="scss" scoped>
.grade-group {
  margin-top: 30px;
}

.item {
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  flex-direction: row;
  padding: 3px 0;

  &:before {
    content: "";
    display: block;
    background: url("../assets/joined-school-list-blue.svg") center center
      no-repeat;
    width: 15px;
    margin-left: 10px;
    margin-right: 10px;
  }

  &:nth-child(even):before {
    background-image: url("../assets/joined-school-list-yellow.svg");
  }

  .info {
    flex: 1;
  }
}

@media (max-width: 480px) {
  .grade-group {
    margin: 20px 10px;
  }

  .item {
    &:before {
      display: none !important;
    }
  }
}
</style>
